import React from 'react';
import { Box, Grid, Typography, Card, CardMedia, CardContent } from '@mui/material';

const Gallery = () => {
  const galleryItems = [
    {
      title: 'Welcome to Zen Life Acupuncture',
      description: 'Our peaceful and welcoming reception area',
      image: '/images/receiption.jpeg' // You'll replace with AI-generated image
    },
    {
      title: 'Treatment Room',
      description: 'Modern and comfortable treatment spaces',
      image: '/images/treatment.jpg'
    },
    {
      title: 'Traditional Herb',
      description: 'Our extensive collection of traditional Chinese herbs',
      image: '/images/herb.jpg'
    },
    {
      title: 'Cupping Therapy',
      description: 'Professional cupping and Gua Sha treatment',
      image: '/images/cupping.jpg'
    }
  ];

  return (
    <Box sx={{ padding: 4, background: theme => theme.palette.background.gradient }}>
      <Typography variant="h2" align="center" gutterBottom>
        Our Facility
      </Typography>
      <Grid container spacing={3}>
        {galleryItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            
            <Card elevation={3}>
              <CardMedia
                component="img"
                height="300"
                image={item.image}
                alt={item.title}
                sx={{
                  objectFit: 'cover',
                  transition: '0.3s',
                  '&:hover': {
                    transform: 'scale(1.02)'
                  }
                }}
              />
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Gallery;